import { useMediaQuery } from '@mui/material';
import { FunctionComponent, ImgHTMLAttributes } from 'react';
import { styleSheet } from '../util/Styles';

export const BackgroundLogo: FunctionComponent<ImgHTMLAttributes<HTMLImageElement>> = (props) => {
	const visible = useMediaQuery(theme => theme.breakpoints.up('md'));

	return visible && <img src='/images/MindLogoWhite.svg' alt='' {...props}
		style={{ ...styles.backgroundLogo, ...props.style }} />;
};

const styles = styleSheet({
	backgroundLogo: {
		height: '15vh',
		position: 'absolute',
		top: '2.5vh',
		right: '5vh',
	} as const
});